import React from "react";
import style from "./style.module.sass";
import Tonality from "./Tonality";
import { useSelector } from "react-redux";
import config from "../../../../config";
import LanguageLevelBar from "./LanguageLevelBar"

function LinguisticParams() {

    const resultData = useSelector(state => state.analyseData.result.resultData);

    const allColors = ["colorGreen","colorBlue","colorYellow","colorRed"]

    const showColor = Object.keys(resultData).reduce((acc,key) => allColors.indexOf(key) > -1 || acc, false);

    const showLanguage = resultData.formulaLanguageLevel > -1

    return <div className={`${style.mainCont} d-flex`}>
        {Object.keys(config.tonalityParameters).filter(v => resultData[v] !== undefined).length > 0 && <Tonality />}
        {showLanguage && <LanguageLevelBar />}
    </div>;
}

export default LinguisticParams;
